import { requestApi } from "../services/api/requestApi";
import {
  loginAnalyticsTracking,
  TRACKING_ACTIONS,
  TRACKING_ERROR_CODES,
  TRACKING_TYPES,
  trackSysConnect,
} from "../services/scopely/loginAnalyticsTracking";
import { useAuthStore } from "../stores/auth";
import type { TUserSessionApi } from "../stores/type/TUserSessionApi";

export const loginByToken = async (userId: string, token: string): Promise<boolean> => {
  const { setUser } = useAuthStore.getState();

  try {
    const scopelyResponse: TUserSessionApi = await requestApi({
      endpoint: `me/fast-login/${userId}/${token}`,
      method: "post",
      useDefaultQueryParams: false,
    });

    if (scopelyResponse?.IsSuccess) {
      localStorage.setItem("sessionToken", scopelyResponse?.Data?.SecretKey);
      localStorage.setItem("loginDate", new Date().toISOString());
      setUser(scopelyResponse?.Data);
      loginAnalyticsTracking({
        type: TRACKING_TYPES.SCOPELY_ID,
        action: TRACKING_ACTIONS.LOGIN_SUCCESSFULL,
      });
      return true;
    }

    return false;
  } catch {
    loginAnalyticsTracking({
      type: TRACKING_TYPES.FAST_LOGIN,
      action: TRACKING_ACTIONS.LOGIN_FAILED,
      errorCode: `${TRACKING_ERROR_CODES.FAST_LOGIN_DATA_IS_NOT_SUCCESS}${TRACKING_ERROR_CODES.UNKNOWN_ERROR}`,
    });
    trackSysConnect({
      type: "Fastlogin",
      errorCode: `${TRACKING_ERROR_CODES.FAST_LOGIN_DATA_IS_NOT_SUCCESS}${TRACKING_ERROR_CODES.UNKNOWN_ERROR}`,
    });
    return false;
  } finally {
    localStorage.removeItem("authorizing");
    localStorage.removeItem("loginProcessing");
  }
};
